import { XIcon } from "@heroicons/react/outline";
import { TriangleAlertIcon } from "lucide-react";
import { observer } from "mobx-react-lite";

import { MessageStore } from "./message-store";

import { Button } from "@/components/ui/button";

const MessageParsingError = ({ message }: { message: MessageStore }) => {
  const { parsingError } = message;

  if (!parsingError) {
    return null;
  }

  return (
    <div className="flex w-full items-center gap-1.5 rounded-md bg-red-500 px-2.5 py-1.5">
      <TriangleAlertIcon className="h-2.5 w-2.5 flex-shrink-0 text-white/90" strokeWidth={2.5} />
      <span className="min-w-0 flex-1 truncate text-xs text-white">{parsingError}</span>

      <Button
        onClick={() => message.dismissParsingError()}
        variant="ghost"
        size="tinyIcon"
        className="h-4 w-4 flex-shrink-0 !bg-transparent p-0 text-white/70 hover:text-white"
      >
        <XIcon className="h-3 w-3" />
      </Button>
    </div>
  );
};

export default observer(MessageParsingError);
